import { render, staticRenderFns } from "./shopHouseManage.vue?vue&type=template&id=2c3030ca&scoped=true"
import script from "./shopHouseManage.vue?vue&type=script&lang=js"
export * from "./shopHouseManage.vue?vue&type=script&lang=js"
import style0 from "./shopHouseManage.vue?vue&type=style&index=0&id=2c3030ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3030ca",
  null
  
)

export default component.exports